import React from 'react'
import styles from './Pill.module.scss'
import clsx from 'clsx'

type pillProps = {
  color: 'warning' | 'error' | 'success' | 'inverse'
  children: React.ReactNode
}

export const Pill = ({ color, children }: pillProps) => {
  return <div className={clsx([styles.pill, styles[color]])}>{children}</div>
}
